export default __webpack_public_path__ + "static/media/pen-navbar.0463c6f2.svg";